import { render, staticRenderFns } from "./ConsultaMassa.vue?vue&type=template&id=1967207a"
import script from "./ConsultaMassa.vue?vue&type=script&lang=js"
export * from "./ConsultaMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports